/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![TiktokNeutralIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABbUlEQVR4nOWUPUsDYQzH70QFRRBHF2cXFzcdrINbLy8tpEkr4lbwAzg4yE2is+AkuggOgqtugk5+ATs5KYhOjoJoK7VKe9dr7Xk9EPxDlrskvyd5nsRx/p2AdBPZat/meTKVKgBY8ykD7NL3/YHUANiwHcdx3DQBNSQ9J9JFERlLB8BN+zsA3/cHvHxxGrGwlMstT0YBgK0IZJVYgHK5PARsG0D60PIc16IAIjJev2Aina/HIOte1+TZbGkCWK/DZUN3QM9yge0iqq/QDwCRaiAp6TuQHgDbKlFpJjEAyc4Ce4Z0JeyTCACkT83TW6WDT5IK9KV1MiN92LaC29QbjVGB3TaD9VFERtp82K5aLv655+SNYN0PDdGhiAx//XaRdT24f+w0FsDLFWaB7C0EuUOyE2C7aXu+WFhw4ircY+xoP0xsF7lAto1s1Q7Jq8i6m8lkBn8L+JTHxTkkPQbSeyB9bbRKj+rfEyXutz4AYARejS7gXXEAAAAASUVORK5CYII=)
 */
export const TiktokNeutralIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M18.31 6.2A5.04 5.04 0 0 1 16.06 2h-3.55v14.47a3 3 0 0 1-2.98 2.92 3.04 3.04 0 0 1 0-6.07c.3 0 .6.05.88.14V9.77A6.6 6.6 0 0 0 3 16.35c0 2.25 1.1 4.24 2.79 5.45A6.42 6.42 0 0 0 9.53 23a6.6 6.6 0 0 0 6.53-6.65V9.02A8.34 8.34 0 0 0 21 10.63v-3.6c-1 0-1.91-.3-2.69-.82Z"
        className={colorClass}
      />
    </svg>
  );
};
